import { NO_DATA_POLICY, type DataPolicyState, type RoomResponse } from '../api/types'

/**
 * The room's data policy state. A rollback re-points the API at the previous image and leaves
 * this SPA in place, and that API's room has no `dataPolicy` at all; read it through here so
 * the Documents and Checklist tabs do not throw for the length of a rollback (the type says
 * the field is always there, which is true of every API that knows ADR 0008).
 */
export const dataPolicyOf = (room: RoomResponse): DataPolicyState =>
  (room as Partial<RoomResponse>).dataPolicy ?? NO_DATA_POLICY

/**
 * Does the organization's data policy (ADR 0008) stand between this caller and handing
 * information over? The server's answer, never a guess: `required` is already false for a room
 * owner and for an organization that has published nothing.
 */
export const dataPolicyBlocks = (room: RoomResponse) => {
  const policy = dataPolicyOf(room)
  return policy.required && !policy.accepted
}
